import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIRoutes } from '../global-misc/api-routes';
import { firstValueFrom } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { TimezoneModel } from '../global-data-models/timezone.model';

@Injectable({ providedIn: 'root' })
export class TimezoneService {
  constructor(private http: HttpClient) {}

  async getAllTimezones(): Promise<TimezoneModel[]> {
    const apiRoute = APIRoutes.TIMEZONES_ROUTE;
    const timezonesResponse = await firstValueFrom(this.http.get<TimezoneModel[]>(apiRoute));
    return timezonesResponse;
  }
}
